/* Baumpaten Newsletter - Anmeldung mit Doppel-Opt-in. Ersetzt Klaviyo (Okt 2026).
   Schickt an einen n8n-Webhook, der die Bestaetigungsmail ueber Brevo ausloest.
   Hier wird NICHTS direkt bei Brevo angemeldet - erst der Klick in der Mail zaehlt. */
(function () {
  'use strict';

  var SPEICHER = {
    angemeldet: 'bd_nl_angemeldet',
    weggeklickt: 'bd_nl_weggeklickt'
  };

  function lies(schluessel) {
    try { return window.localStorage.getItem(schluessel); } catch (e) { return null; }
  }
  function schreib(schluessel, wert) {
    try { window.localStorage.setItem(schluessel, wert); } catch (e) { /* privater Modus */ }
  }

  function istMailPlausibel(wert) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(wert);
  }

  /* ---------- Formular ---------- */

  function formularVerdrahten(formular) {
    if (formular.dataset.bdBereit) return;
    formular.dataset.bdBereit = '1';

    var meldung = formular.querySelector('[data-bd-meldung]');
    var knopf = formular.querySelector('[data-bd-knopf]');
    var mailfeld = formular.querySelector('input[type="email"]');
    var ziel = formular.dataset.bdZiel;

    function sagen(text, art) {
      if (!meldung) return;
      meldung.textContent = text;
      meldung.className = 'bd-nl__meldung' + (art ? ' bd-nl__meldung--' + art : '');
    }

    formular.addEventListener('submit', function (ereignis) {
      ereignis.preventDefault();

      var koeder = formular.querySelector('[data-bd-koeder]');
      if (koeder && koeder.value) return; // Bot hat das versteckte Feld ausgefuellt

      var mail = ((mailfeld && mailfeld.value) || '').trim();
      if (!istMailPlausibel(mail)) {
        if (mailfeld) { mailfeld.setAttribute('aria-invalid', 'true'); mailfeld.focus(); }
        sagen('Bitte pruef die E-Mail-Adresse noch einmal.', 'fehler');
        return;
      }
      if (mailfeld) mailfeld.removeAttribute('aria-invalid');

      var haken = formular.querySelector('[data-bd-einwilligung]');
      if (haken && !haken.checked) {
        sagen('Ohne deine Einwilligung duerfen wir dir nichts schicken.', 'fehler');
        haken.focus();
        return;
      }

      if (!ziel) { sagen('Die Anmeldung ist gerade nicht erreichbar.', 'fehler'); return; }

      if (knopf) {
        knopf.disabled = true;
        knopf.dataset.bdText = knopf.textContent;
        knopf.textContent = 'Moment ...';
      }
      sagen('', '');

      var vorname = formular.querySelector('[data-bd-vorname]');
      var nutzlast = {
        email: mail,
        vorname: vorname ? vorname.value.trim() : '',
        quelle: formular.dataset.bdQuelle || 'Shop',
        seite: window.location.pathname,
        zeitpunkt: new Date().toISOString()
      };

      fetch(ziel, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nutzlast),
        keepalive: true
      })
        .then(function (antwort) {
          if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
          schreib(SPEICHER.angemeldet, '1');
          var fertig = formular.querySelector('[data-bd-fertig]');
          var fassung = formular.querySelector('[data-bd-fassung]');
          if (fertig) {
            fertig.hidden = false;
            if (fassung) fassung.hidden = true;
            var ueberschrift = fertig.querySelector('h3');
            if (ueberschrift) { ueberschrift.setAttribute('tabindex', '-1'); ueberschrift.focus(); }
          } else {
            sagen('Fast geschafft - schau in dein Postfach und bestaetige die Anmeldung.', 'gut');
          }
        })
        .catch(function () {
          sagen('Das hat gerade nicht geklappt. Bitte versuch es spaeter noch einmal.', 'fehler');
        })
        .then(function () {
          if (knopf) { knopf.disabled = false; knopf.textContent = knopf.dataset.bdText || 'Anmelden'; }
        });
    });
  }

  /* ---------- Pop-up ---------- */

  function popupVerdrahten(popup) {
    var karte = popup.querySelector('.bd-nl-popup__karte');
    if (!karte) return;
    var verzoegerung = parseInt(popup.dataset.bdVerzoegerung, 10) || 8;
    var pause = parseInt(popup.dataset.bdPause, 10) || 30;
    var vorherFokussiert = null;
    var schonGezeigt = false;

    function darfZeigen() {
      if (lies(SPEICHER.angemeldet)) return false;
      var bis = parseInt(lies(SPEICHER.weggeklickt), 10);
      if (bis && Date.now() < bis) return false;
      // Im Kaufvorgang und im Konto nicht stoeren
      if (/\/(cart|checkouts?|account)(\/|$)/.test(window.location.pathname)) return false;
      if (new URLSearchParams(window.location.search).has('newsletter')) return false;
      return true;
    }

    function fokussierbare() {
      return Array.prototype.filter.call(
        karte.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
    }

    function beiTaste(ereignis) {
      if (ereignis.key === 'Escape') { schliessen(); return; }
      if (ereignis.key !== 'Tab') return;
      var liste = fokussierbare();
      if (!liste.length) return;
      var erster = liste[0];
      var letzter = liste[liste.length - 1];
      if (ereignis.shiftKey && document.activeElement === erster) {
        ereignis.preventDefault(); letzter.focus();
      } else if (!ereignis.shiftKey && document.activeElement === letzter) {
        ereignis.preventDefault(); erster.focus();
      }
    }

    function oeffnen() {
      if (schonGezeigt || !darfZeigen()) return;
      schonGezeigt = true;
      vorherFokussiert = document.activeElement;
      popup.hidden = false;
      requestAnimationFrame(function () { popup.classList.add('ist-offen'); });
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', beiTaste);
      var zuerst = karte.querySelector('input[type="email"]') || karte.querySelector('[data-bd-zu]');
      if (zuerst) zuerst.focus({ preventScroll: true });
    }

    function schliessen() {
      popup.classList.remove('ist-offen');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', beiTaste);
      schreib(SPEICHER.weggeklickt, String(Date.now() + pause * 86400000));
      window.setTimeout(function () { popup.hidden = true; }, 250);
      if (vorherFokussiert && vorherFokussiert.focus) vorherFokussiert.focus();
    }

    popup.addEventListener('click', function (ereignis) {
      if (ereignis.target === popup || (ereignis.target.closest && ereignis.target.closest('[data-bd-zu]'))) {
        schliessen();
      }
    });

    if (!darfZeigen()) return;
    window.setTimeout(oeffnen, verzoegerung * 1000);

    var beiScroll = function () {
      var hoehe = document.documentElement.scrollHeight - window.innerHeight;
      if (hoehe > 0 && window.scrollY / hoehe > 0.45) {
        oeffnen();
        window.removeEventListener('scroll', beiScroll);
      }
    };
    window.addEventListener('scroll', beiScroll, { passive: true });
  }

  /* ---------- Banner nach dem Bestaetigungsklick in der Mail ---------- */

  function bestaetigungZeigen() {
    if (new URLSearchParams(window.location.search).get('newsletter') !== 'bestaetigt') return;
    schreib(SPEICHER.angemeldet, '1');

    var banner = document.createElement('div');
    banner.className = 'bd-nl-banner';
    banner.setAttribute('role', 'status');

    var text = document.createElement('span');
    text.textContent = 'Danke - deine Anmeldung ist bestaetigt. Willkommen bei den Baumpaten.';
    banner.appendChild(text);

    var zu = document.createElement('button');
    zu.type = 'button';
    zu.setAttribute('aria-label', 'Hinweis schliessen');
    zu.textContent = '×';
    zu.addEventListener('click', function () { banner.remove(); });
    banner.appendChild(zu);

    document.body.appendChild(banner);
    window.setTimeout(function () { banner.remove(); }, 12000);
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bd-formular]'), formularVerdrahten);
    var popup = document.querySelector('[data-bd-popup]');
    if (popup) popupVerdrahten(popup);
    bestaetigungZeigen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
